jQuery( document ).ready(function( $ ) {
    $('.iconRow__item').matchHeight();
});

